import moment from 'moment';
import React, { Component } from 'react';
import { withRouter  } from 'react-router-dom';
import { optionsMovementCash, optionsTransaction, roleId, urls } from '../../constants/app';
import request from '../../action/utils/request';
import Loader from '../utils/Loader';
import ActionMenu from '../utils/ActionMenu';
import ErrorBoundary from '../utils/ErrorBoundary';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

function ItemRow(props) {
    const { article, item, role, onEditArticle, openRefund, isMobile, history } = props;
    const actions = [
        { name: 'Редактирование', icon: 'flaticon2-contract', access: [roleId.admin], action: () => onEditArticle(item, article) },
        { name: 'Возврат', icon: 'flaticon-reply', access: [roleId.admin, roleId.manager, roleId.regionalDirector, roleId.operationDirector, roleId.chiefCommoditySpecialist, roleId.accountant, roleId.chiefAccountant], action: () => openRefund(item, article)}
    ].filter((action) => {
        if (action.access && !action.access.includes(role)) return false;
        if (article.refunded || article.refund || article.notRefunded) return false;
        return true;
    });

    const renderType = (typeMovementCash) => {
        if (typeMovementCash === 'incasso') return 'Инкассация';
        if (typeMovementCash === 'expenditure') return 'Изъятие';
        if (typeMovementCash === 'income') return 'Внесение';
        return;
    };

    const transactionOprion = optionsTransaction.find((option) => option.value === article.typeTransaction);
    const movementCashOption = optionsMovementCash.find((option) => option.value === item.typeMovementCash);

    if (isMobile) return(
        <tr key={item.id} className="kt-datatable__row" style={{ backgroundColor: '#f7f7f7' }}>
            <div className='mobile_div_flex column padding10px'>
                <div className='mobile_div_flex gap0px'>
                    <div className='mobile_div_flex gap0px' style={{ width: '50%' }}>
                        <span style={{ color: '#000' }}>{`Время: ${article.created_at}`}</span>
                    </div>
                    <div className='mobile_div_flex gap0px' style={{ width: '50%', justifyContent: 'flex-end' }}>
                        {actions && actions.length > 0 && <ActionMenu actions={actions}/>}
                    </div>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <span style={{ color: '#000' }}>{`Операция: ${article.name}`}</span>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                        <span style={{ color: '#000' }}>
                            {`Тип транзакции: ${(transactionOprion && transactionOprion.label) ? transactionOprion.label : 'Неизвестно'}`}
                        </span>
                    </div>
                    <div className='mobile_div_flex' style={{ width: '50%' }}>
                        <span style={{ color: '#000' }}>
                            {`Тип: ${(movementCashOption && movementCashOption.label) ? movementCashOption.label : 'Неизвестно'}`}
                        </span>
                    </div>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <div className='mobile_div_flex' style={{ width: '50%' }}> 
                        <span style={{ color: '#000' }}>{`Сумма: ${article.sum}`}</span>
                    </div>
                    <div className='mobile_div_flex' style={{ width: '50%' }}> 
                        <span style={{ color: '#000' }}>{`Автор: ${article.author}`}</span>
                    </div>
                </div>
                <div className='mobile_div_flex gap0px'>
                    <span style={{ color: '#000' }}>{`Примечание: ${article.comment ? article.comment : ''}`}</span>
                    {article.invoiceId && <button data-tip="Просмотр" className="btn btn-sm btn-clean btn-icon btn-icon-md" onClick={() => history.push(`/accounting/invoice/detail/${article.invoiceId}`)}> <i className='la la-eye'/> </button>}
                </div>                                                    
            </div>
        </tr>
    );

    return (
        <tr key={item.id + '_articles_' + article.id} className="kt-datatable__row" style={{ backgroundColor: '#f7f7f7' }}>
            <td className="kt-datatable__cell" style={{ width: '15%' }}>
                <span>
                    {article.created_at}
                </span>                                    
            </td>
            <td className="kt-datatable__cell" style={{ display: 'flex' }}>
                <span>{article.comment}</span>
                {article.invoiceId && <button data-tip="Просмотр" className="btn btn-sm btn-clean btn-icon btn-icon-md" onClick={() => history.push(`/accounting/invoice/detail/${article.invoiceId}`)}> <i className='la la-eye'/> </button>}
            </td>
            <td className="kt-datatable__cell" style={{ width: '6%' }}>
                <span>{(transactionOprion && transactionOprion.label) ? transactionOprion.label : 'Неизвестно'}</span>
                <span>{renderType(article.typeMovementCash)}</span>
            </td>
            <td className="kt-datatable__cell" style={{ width: '10%' }}>
                <span>{article.name}</span>
            </td>
            <td className="kt-datatable__cell" style={{ width: '10%' }}>
            </td>                            
            <td className="kt-datatable__cell" style={{ width: '15%' }}>
                <span>{article.typeMovementCash === 'income' ? article.sum : ''}</span>
            </td>
            {/* {<td className="kt-datatable__cell" style={{ width: '10%' }}>
                <span>{el.typeMovementCash === 'incasso' ? el.sum : ''}</span>
            </td>} */}
            <td className="kt-datatable__cell" style={{ width: '15%' }}>
                <span>{article.typeMovementCash === 'expenditure' ? article.sum : ''}</span>
            </td>
            <td className="kt-datatable__cell" style={{ width: '14%' }}>
                <div style={actions && actions.length > 0 ? { display: 'flex', justifyContent: 'space-between' } : { display: 'flex', justifyContent: 'start' }}>
                    <span style={{ overflowWrap: 'break-word' }}>{article.author}</span>
                    {actions && actions.length > 0 && <ActionMenu actions={actions}/>}
                </div>
            </td>
        </tr>
    );
}

class WorkingShiftsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showArticles: Array(props.items.length).fill(false),
            ordersData: {},
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.loadOrdersData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.items !== prevProps.items) {
            this.loadOrdersData();
        }
    }

    toggleDetails(index) {
        this.setState(prevState => {
            const updatedshowArticles = [...prevState.showArticles]
            updatedshowArticles[index] = !updatedshowArticles[index]
            return { showArticles: updatedshowArticles }
        })
    }

    loadOrdersData = async () => {
        const { items } = this.props;
        this.setState({ loading: true, error: null });
        
        try {
            const openShifts = items.filter(shift => !shift.closed_at);
            const ordersData = {};
            
            await Promise.all(openShifts.map(async shift => {
                ordersData[shift.id] = await this.loadShiftOrders(shift);
            }));
            
            this.setState({ ordersData, loading: false });
        } catch (error) {
            if (error.name !== 'AbortError') {
                this.setState({ 
                    error, 
                    loading: false 
                });
                console.error('Ошибка загрузки заказов:', error);
            }
        }
    };

    loadShiftOrders = async (shift) => {        
        try {
            const threeMonthsAgo = moment().subtract(3, 'months');
            const isRecentShift = moment(shift.created_at).isAfter(threeMonthsAgo);
            const type = isRecentShift ? 'orders' : 'archive';

            const dataParams = {
                workingShiftId: shift.id || null,
                payments: ['cash', 'terminal'],
                type
            };

            const ordersData = await request({ method: 'post', url: `${urls.workingShift}/ordersList`, data: dataParams });            
            return ordersData || [];
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error(`Ошибка загрузки заказов для смены ${shift.id}:`, error);
            }
            return [];
        }
    };

    calculateRevenue = (data, paymentMethod) => {
        if (!data || !Array.isArray(data)) return 0;
        
        return data.reduce((acc, order) => {
            if (order.payment === paymentMethod) {
                return acc + parseFloat(order.totalPrice || 0);
            } else {
                return acc;
            }
        }, 0);
    };

    onEditArticle = (shift, artilce) => {
        this.props.setWorkingShift(shift);
        this.props.onEditArticle(artilce);
    };

    openRefund = (shift, article) => {
        const value = {
            article,
            workingShiftId: shift.id,
            point: shift.point,
        };
        return this.props.setActiveModalAction({ field: 'workingShiftRefundArticles', value });
    };

    renderRevenueShift(field, item) {
        if (item.closed_at != null) {
            if (field === 'cash') return parseFloat(item.revenueCash || 0).toFixed(2);
            return parseFloat(item.revenueNoncash || 0).toFixed(2);
        }

        const orders = this.state.ordersData[item.id] || [];
        const paymentMethod = field === 'cash' ? 'cash' : 'terminal';
        const revenue = this.calculateRevenue(orders, paymentMethod);
        
        return revenue.toFixed(2);;
    }

    renderFinalBalanceShift(field, item) {
        if (item.closed_at != null) {
            if (field === 'cash') return parseFloat(item.finalBalanceCash || 0).toFixed(2)
            return parseFloat(item.finalBalanceNoncash || 0).toFixed(2);
        }

        const revenue = parseFloat(this.renderRevenueShift(field, item));
        const initial = parseFloat(field === 'cash' ? item.initialBalanceCash || 0 : item.initialBalanceNoncash || 0);
        const depositing = parseFloat(field === 'cash' ? item.depositingCash || 0 : item.depositingNoncash || 0);
        const withdrawal = parseFloat(field === 'cash' ? item.withdrawalCash || 0 : item.withdrawalNoncash || 0);
        const incasso = field === 'cash' ? parseFloat(item.incassoCash || 0) : 0;

        return (initial + revenue + depositing + incasso - withdrawal).toFixed(2);
    }

    renderResultValue(field, type) {
        switch(field) {
            case 'revenue':{
                return (this.props.items.reduce((acc, item) => {
                    if(type === 'all') {
                        return acc + parseFloat(this.renderRevenueShift('cash', item) || 0) + parseFloat(this.renderRevenueShift('noncash', item) || 0);
                    }
                    return acc + parseFloat(this.renderRevenueShift(type, item) || 0);
                }, 0)).toFixed(2)
            }
            case 'finalBalance': {
                return (this.props.items.reduce((acc, item) => {
                    if(type === 'all') {
                        return acc + parseFloat(this.renderFinalBalanceShift('cash', item) || 0) + parseFloat(this.renderFinalBalanceShift('noncash', item) || 0);
                    }
                    return acc + parseFloat(this.renderFinalBalanceShift(type, item) || 0);
                }, 0)).toFixed(2)
            }
            case 'depositing': {
                return (this.props.items.reduce((acc, item) => {
                    if(type === 'cash') {
                        return acc + parseFloat(item.depositingCash || 0);
                    }

                    if(type === 'noncash') {
                        return acc + parseFloat(item.depositingNoncash || 0);
                    }

                    return acc + parseFloat(item.depositingCash || 0) + parseFloat(item.depositingNoncash || 0);
                }, 0)).toFixed(2)
            }
            case 'withdrawal': {
                return (this.props.items.reduce((acc, item) => {
                    if(type === 'cash') {
                        return acc + parseFloat(item.withdrawalCash || 0);
                    }

                    if(type === 'noncash') {
                        return acc + parseFloat(item.withdrawalNoncash || 0);
                    }

                    return acc + parseFloat(item.withdrawalCash || 0) + parseFloat(item.withdrawalNoncash || 0);
                }, 0)).toFixed(2)
            }
            case 'incasso': {
                return (this.props.items.reduce((acc, item) => {
                    return acc + parseFloat(item.incassoCash || 0);
                }, 0)).toFixed(2)
            }            
            default: break;
        }
    }

    renderThead() {
        return (
            <thead className="kt-datatable__head" style={{ backgroundColor: '#f7f7f7' }}>
                <tr className="kt-datatable__row">                    
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Открыта</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Закрыта</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '6%', paddingTop: '10px', paddingBottom: '10px' }}>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Нач. остаток</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Выручка</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Внесение</span>
                    </th>
                    {/* {<th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Инкассация</span>
                    </th>} */}
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Изъятие</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '14%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Итог</span>
                    </th>
                </tr>
            </thead>
        );
    }

    renderType = (typeMovementCash) => {
        if (typeMovementCash === 'incasso') return 'Инкассация';
        if (typeMovementCash === 'expenditure') return 'Изъятие';
        if (typeMovementCash === 'income') return 'Внесение';
        return;
    }
    
    renderBody() {
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map((item, index) => {
                        return (
                            <>
                                <tr key={item.id + '_cash'} className="kt-datatable__row">                            
                                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        <span>
                                            {moment(item.opened_at).format('DD.MM.YYYY HH:mm:ss')}
                                        </span>                                    
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        <span>
                                            {item.closed_at ? moment(item.closed_at).format('DD.MM.YYYY HH:mm:ss') : ''}
                                        </span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '6%' }}>
                                        <span>Наличные</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                        <span>{item.initialBalanceCash ? parseFloat(item.initialBalanceCash).toFixed(2) : '0.00'}</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                        <span>{this.renderRevenueShift('cash', item)}</span>
                                    </td>                            
                                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        <span>{item.depositingCash ? parseFloat(item.depositingCash).toFixed(2) : '0.00'}</span>
                                    </td>
                                    {/* {<td className="kt-datatable__cell" style={{ width: '10%' }}>
                                        <span>{item.incassoCash ? parseFloat(item.incassoCash).toFixed(2) : '0.00'}</span>
                                    </td>} */}
                                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                            <span>{item.withdrawalCash ? parseFloat(item.withdrawalCash).toFixed(2) : '0.00'}</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '14%' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                            <span style={{ color: '#595d6e', alignContent: 'center' }}>{this.renderFinalBalanceShift('cash', item)}</span> 
                                            {this.props.role === roleId.admin && <button onClick={() => this.props.onDelete(item.id)} className='btn btn-sm btn-icon btn-icon-md btn-danger'> <i className='flaticon2-trash'/> </button>}
                                        </div>
                                    </td>
                                </tr>
                                <tr key={item.id + '_noncash'} className="kt-datatable__row">                            
                                    <td className="kt-datatable__cell"  style={{ width: '15%' }}>
                                        <span>{item.shiftOpener ? item.shiftOpener : ''}</span>                     
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        <span>{item.shiftCloser ? item.shiftCloser : ''}</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '6%' }}>
                                        <span>Безнал.</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                        <span>{item.initialBalanceNoncash ? parseFloat(item.initialBalanceNoncash).toFixed(2) : '0.00'}</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                        <span>{this.renderRevenueShift('noncash', item)}</span>
                                    </td>                            
                                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        <span>{item.depositingNoncash ? parseFloat(item.depositingNoncash).toFixed(2) : '0.00'}</span>
                                    </td>
                                    {/* {<td className="kt-datatable__cell" style={{ width: '10%' }}>
                                    </td>} */}
                                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        <span>{item.withdrawalNoncash ? parseFloat(item.withdrawalNoncash).toFixed(2) : '0.00'}</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '14%' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                                            <span style={{ color: '#595d6e', alignContent: 'center' }}>{this.renderFinalBalanceShift('noncash', item)}</span> 
                                            {this.props.role === roleId.admin && <button onClick={() => this.props.onRecalculation(item)} className='btn btn-sm btn-icon btn-icon-md btn-secondary'> <i className='la la-refresh'/> </button>}
                                        </div>
                                    </td>
                                </tr>
                                {item.articlesCashes && item.articlesCashes.length > 0 && !this.state.showArticles[index] &&
                                    <tr key={item.id + '_articlesButton'} className="kt-datatable__row">
                                        <td className="kt-datatable__cell">
                                            <button onClick={() => this.toggleDetails(index)} className='btn btn-secondary'> Показать операции </button>
                                        </td>
                                    </tr>
                                }
                                {this.state.showArticles[index] &&
                                <>
                                    <tr key={item.id + '_articlesHead'} className="kt-datatable__row" style={{ backgroundColor: '#f7f7f7' }}>
                                        <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                            <span style={{ color: '#000' }}>Время создания</span>                                    
                                        </td>
                                        <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                            <span style={{ color: '#000' }}>Примечание</span>
                                        </td>
                                        <td className="kt-datatable__cell" style={{ width: '6%' }}>
                                        </td>
                                        <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                            <span style={{ color: '#000' }}></span>
                                        </td>
                                        <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                        </td>                            
                                        <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        </td>
                                        {/* {<td className="kt-datatable__cell" style={{ width: '10%' }}>
                                        </td>} */}
                                        <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                        </td>
                                        <td className="kt-datatable__cell" style={{ width: '14%' }}>
                                            <span style={{ color: '#000' }}>Пользователь</span>
                                        </td>
                                    </tr>
                                    {item.articlesCashes.map((el) => (
                                        <ErrorBoundary key={item.id} fallback={<tr className='kt-datatable__row'>{`Не удалось отобразить статью id: ${item.id}. Попробуйте позже.`}</tr>}>
                                            <ItemRow history={this.props.history} item={item} article={el} role={this.props.role} onEditArticle={this.onEditArticle} openRefund={this.openRefund}/>
                                        </ErrorBoundary>
                                    ))}
                                </>
                                }
                            </>
                        );
                    }) 
                }
                <tr className="kt-datatable__row" style={{ height: '40px' }}>
                </tr>
                <tr className="kt-datatable__row" style={{ backgroundColor: '#f7f7f7' }}>
                    <td className="kt-datatable__cell">
                        <span>Итог</span>
                    </td>
                </tr>
                <tr className="kt-datatable__row">                            
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>                                                           
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '6%' }}>
                        <span>Наличные</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>{this.renderResultValue('revenue', 'cash')}</span>
                    </td>                            
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                        <span>{this.renderResultValue('depositing', 'cash')}</span>
                    </td>
                    {/* {<td className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>{this.renderResultValue('incasso', 'cash')}</span>
                    </td>} */}
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                        <span>{this.renderResultValue('withdrawal', 'cash')}</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '14%' }}>
                        <span>{this.renderResultValue('finalBalance', 'cash')}</span>
                    </td>
                </tr>
                <tr className="kt-datatable__row">                            
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '6%' }}>
                        <span>Безнал.</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>{this.renderResultValue('revenue', 'noncash')}</span>
                    </td>                            
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                        <span>{this.renderResultValue('depositing', 'noncash')}</span>
                    </td>
                    {/* {<td className="kt-datatable__cell" style={{ width: '10%' }}>
                    </td>} */}
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                        <span>{this.renderResultValue('withdrawal', 'noncash')}</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '14%' }}>
                        <span>{this.renderResultValue('finalBalance', 'noncash')}</span>
                    </td>
                </tr>
                <tr className="kt-datatable__row">                            
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>                                  
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '6%' }}>
                        <span>Итого</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>{this.renderResultValue('revenue', 'all')}</span>
                    </td>                            
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                        <span>{this.renderResultValue('depositing', 'all')}</span>
                    </td>
                    {/* {<td className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>{this.renderResultValue('incasso', 'all')}</span>
                    </td>} */}
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                        <span>{this.renderResultValue('withdrawal', 'all')}</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '14%' }}>
                        <span>{this.renderResultValue('finalBalance', 'all')}</span>
                    </td>
                </tr>
            </tbody>
        );
    }

    renderBodyMobile() {
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map((item, index) => {
                        return (
                            <tr className="kt-datatable__row" key={item.id}>
                                <div className='ws_column' style={{ width: '100%', gap: '0px' }}>
                                    <div className='workingShift_row' style={{ width: '100%', borderBottom: 'none' }}>
                                        <div className='workingShift_cell' style={{ flex: 1 }}>
                                            <div className='ws_column' style={{ flex: 1 }}>
                                                <span style={{ fontWeight: 600}}>Открыта</span>
                                                <span>{moment(item.opened_at).format('DD.MM.YYYY HH:mm:ss')}</span>
                                                <span>{item.shiftOpener ? item.shiftOpener : ''}</span>
                                            </div>
                                            <div className='ws_column' style={{ flex: 1 }}>
                                                <span style={{ fontWeight: 600}}>Закрыта</span>
                                                <span>{item.closed_at ? moment(item.closed_at).format('DD.MM.YYYY HH:mm:ss') : ''}</span>
                                                <span>{item.shiftCloser ? item.shiftCloser : ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='workingShift_row' style={{ width: '100%'}}>
                                        <div className='workingShift_cell' style={{ flexDirection: 'column', flex: 1 }}>
                                            <span style={{ fontWeight: 600}}> Наличные </span>
                                            <span>{`Нач. ост. ${item.initialBalanceCash ? parseFloat(item.initialBalanceCash).toFixed(2) : '0.00'}`}</span>
                                            <span>{`Выручка ${this.renderRevenueShift('cash', item)}`}</span>
                                            <span>{`Внесено ${item.depositingCash ? parseFloat(item.depositingCash).toFixed(2) : '0.00'}`}</span>
                                            {/* {<span>{`Инкассировано ${item.incassoCash ? parseFloat(item.incassoCash).toFixed(2) : '0.00'}`}</span>} */}
                                            <span>{`Изъято ${item.withdrawalCash ? parseFloat(item.withdrawalCash).toFixed(2) : '0.00'}`}</span>
                                            <span>{`Итого ${this.renderFinalBalanceShift('cash', item)}`}</span>
                                        </div>
                                        <div className='workingShift_cell' style={{ flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
                                            <div className='ws_column'>
                                                <span style={{ fontWeight: 600}}> Безнал. </span>
                                                <span>{`Нач. ост. ${item.initialBalanceNoncash ? parseFloat(item.initialBalanceNoncash).toFixed(2) : '0.00'}`}</span>
                                                <span>{`Выручка ${this.renderRevenueShift('noncash', item)}`}</span>
                                                <span>{`Внесено ${item.depositingNoncash ? parseFloat(item.depositingNoncash).toFixed(2) : '0.00'}`}</span>
                                            </div>
                                            <div className='ws_column'>
                                                <span>{`Изъято ${item.withdrawalNoncash ? parseFloat(item.withdrawalNoncash).toFixed(2) : '0.00'}`}</span>
                                                <span>{`Итого ${this.renderFinalBalanceShift('noncash', item)}`}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {item.articlesCashes && item.articlesCashes.length > 0 && !this.state.showArticles[index] &&
                                        <div className='workingShift_row'>
                                            <button onClick={() => this.toggleDetails(index)} className='btn btn-secondary'> Показать операции </button>
                                        </div>
                                    }
                                    {this.state.showArticles[index] &&
                                    item.articlesCashes.map((el) => (
                                        <ErrorBoundary key={item.id} fallback={<tr className='kt-datatable__row'>{`Не удалось отобразить статью id: ${item.id}. Попробуйте позже.`}</tr>}>
                                            <ItemRow history={this.props.history} isMobile={true} item={item} article={el} role={this.props.role} onEditArticle={this.onEditArticle} openRefund={this.openRefund}/>
                                        </ErrorBoundary>
                                    ))}
                                </div>
                            </tr>
                        );
                    }) 
                }
                <tr className="kt-datatable__row" style={{ backgroundColor: '#f7f7f7', marginTop: '10px' }}>
                    <td className="kt-datatable__cell">
                        <span>Итог</span>
                    </td>
                </tr>                
                <tr className="kt-datatable__row">
                    <div className='workingShift_row' style={{ width: '100%'}}>
                        <div className='workingShift_cell' style={{ width: '100%', flexDirection: 'column', gap: '0px' }}>
                            <div className='workingShift_row' style={{ width: '100%', borderBottom: 'none' }}>
                                <div className='workingShift_cell' style={{ flexDirection: 'column', flex: 1 }}>
                                    <span style={{ fontWeight: 600}}> Наличные </span>
                                    <span>{`Выручка ${this.renderResultValue('revenue', 'cash')}`}</span>
                                    <span>{`Внесено ${this.renderResultValue('depositing', 'cash')}`}</span>
                                    {/* {<span>{`Инкассировано ${this.renderResultValue('incasso', 'cash')}`}</span>} */}
                                    <span>{`Изъято ${this.renderResultValue('withdrawal', 'cash')}`}</span>
                                    <span>{`Итого ${this.renderResultValue('finalBalance', 'cash')}`}</span>
                                </div>
                                <div className='workingShift_cell' style={{ flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
                                    <div className='ws_column'>
                                        <span style={{ fontWeight: 600}}> Безнал. </span>
                                        <span>{`Выручка ${this.renderResultValue('revenue', 'noncash')}`}</span>
                                        <span>{`Внесено ${this.renderResultValue('depositing', 'noncash')}`}</span>
                                    </div>
                                    <div className='ws_column'>
                                        <span>{`Изъято ${this.renderResultValue('withdrawal', 'noncash')}`}</span>
                                        <span>{`Итого ${this.renderResultValue('finalBalance', 'noncash')}`}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='workingShift_row' style={{ width: '100%', borderBottom: 'none' }}>
                                <div className='workingShift_cell' style={{ flexDirection: 'column', flex: 1 }}>
                                    <span style={{ fontWeight: 600}}> Итого </span>
                                    <span>{`Выручка ${this.renderResultValue('revenue', 'all')}`}</span>
                                    <span>{`Внесено ${this.renderResultValue('depositing', 'all')}`}</span>
                                    {/* {<span>{`Инкассировано ${this.renderResultValue('incasso', 'all')}`}</span>} */}
                                    <span>{`Изъято ${this.renderResultValue('withdrawal', 'all')}`}</span>
                                    <span>{`Итого ${this.renderResultValue('finalBalance', 'all')}`}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </tr>
            </tbody>
        );
    }

    render() {
        if (this.props.items.length === 0) {
            return (
                <div className="text-center p-5">Данные не найдены</div>
            );
        }

        if (this.props.loading) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }

        if (this.state.error) {
            return (
                <div className="text-center text-danger p-5">
                    Ошибка загрузки данных: {(this.state.error && this.state.error.message) ? this.state.error.message : ''}
                    <button 
                    className="btn btn-primary ml-3"
                    onClick={this.loadOrdersData}
                    >
                        Повторить
                    </button>
                </div>
            );
        }

        if(window.innerWidth <= 900) 
            return (
                <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                    {this.renderBodyMobile()}
                </table>
            );

        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderThead()}
                {this.renderBody()}
            </table>
        );
    }
}

export default withRouter(WorkingShiftsTable);